import React, {useEffect} from 'react';
import {injectIntl} from "react-intl";

function Captcha({intl, settings, ...rest}) {
  const {errors} = settings || {};
  const hasErrors = (errors && errors.captchaToken);
  const renderErrors = () => {
    const renderable = [];
    if (hasErrors) {
      renderable.push(
        <div key={`errorField-captchaToken`} className="form-group__feedback">{intl.formatMessage({id: "Schema.Captcha.ValidationError"})}</div>
      );
    }
    return renderable;
  };

  useEffect(() => {
    const captchaWidgetId = 'mrnd_captcha';
    let attempts = 0;
    let retryTimer;

    const initializeCaptcha = () => {
      if (!window.captcha?.init) {
        return false;
      }

      window.captcha.init(captchaWidgetId, window.rbdCaptchaSiteKey, window.captchaType);
      return true;
    };

    if (!initializeCaptcha()) {
      retryTimer = window.setInterval(() => {
        attempts += 1;
        if (initializeCaptcha() || attempts >= 50) {
          window.clearInterval(retryTimer);
        }
      }, 100);
    }

    return () => {
      if (retryTimer) {
        window.clearInterval(retryTimer);
      }
    };
  }, []);

  return (
    <div className={`form-group ${hasErrors ? 'form-group--error' : ''}`}>
      <div data-captcha-widget-id="mrnd_captcha"></div>
      {renderErrors()}
    </div>
  );

}

export default injectIntl(Captcha);
